/* eslint-disable prettier/prettier */
import { emojiIconMap } from '../../utils/emojiIconMap';
import { CollapsibleSection } from '../file/CollapsibleSection';
import { ComparisonTable } from './ComparisonTable';

export const GeneralInfoComparisonSection = ({
  generalInfo,
  showDifferences,
}: {
  generalInfo: any;
  showDifferences?: boolean;
}) => {
  if (!generalInfo) return null;
  const hasDifferences = Object.values(generalInfo).some((val: any) => val.isDifferent);
  if (showDifferences && !hasDifferences) return null;

  return (
    <CollapsibleSection title="General Info " icon={emojiIconMap['General Info']}>
      <ComparisonTable
        data={generalInfo}
        fieldLabels={{
          programNumber: 'Program Number',
          UMR: 'UMR',
          mainLineOfBusiness: 'Main Line of Business',
          subLineOfBusiness: 'Sub Line of Business',
          typeOfTreaty: 'Type of Treaty',
          businessTitle: 'Business Title',
          underwritingYear: 'Underwriting Year',
          inceptionDate: 'Inception Date',
          expiryDate: 'Expiry Date',
          multiYear: 'Multi-Year',
          contractDuration: 'Contract Duration',
          mainTerritorialScope: 'Main Territorial Scope',
          contractCurrency: 'Contract Currency',
          claimBasis: 'Claim Basis',
          accountingBasis: 'Accounting Basis',
          brokerageRate: 'Brokerage Rate',
          taxesRate: 'Taxes Rate',
        }}
        showDifferences={showDifferences}
      />
    </CollapsibleSection>
  );
};
